// 员工管理的接口
import { get, post, deleteApi, postJson } from "../axios";

const EMPLOYEE_BASE_PATH = "/platform-user";

// 添加编辑账号
export const addOrUpdate = (p) =>
  postJson(`${EMPLOYEE_BASE_PATH}/addOrUpdate`, p);

// 批量分配数据权限
export const addUserDataPermission = (p) =>
  postJson(`${EMPLOYEE_BASE_PATH}/addUserDataPermission`, p);

// 批量分配角色
export const addUserRole = (p) =>
  postJson(`${EMPLOYEE_BASE_PATH}/addUserRole`, p);

// 删除账号
export const deleteUser = (p) =>
  deleteApi(`${EMPLOYEE_BASE_PATH}/delete/${p}`, p);

// 获取帐号详细信息
export const getDetailUser = (p) => get(`${EMPLOYEE_BASE_PATH}/detail/${p}`, p);

// 获取用户分配数据权限的关联店铺列表
export const getDataPermissionListByUserId = (p) =>
  get(`${EMPLOYEE_BASE_PATH}/getDataPermissionListByUserId`, p);

// 获取当前账号可分配数据权限的关联店铺列表
export const getPlatformSellerList = (p) =>
  get(`${EMPLOYEE_BASE_PATH}/getPlatformSellerList`, p);

// 获取账号管理分页信息
export const getUsePage = (p) => get(`${EMPLOYEE_BASE_PATH}/page`, p);

// 修改账号信息及账号密码
export const changeUserPwd = (p) =>
  postJson(`${EMPLOYEE_BASE_PATH}/password`, p);

// 停用启用账号
export const setState = (p) =>
  post(`${EMPLOYEE_BASE_PATH}/status/userId/${p.userId}/state/${p.state}`, p);

// 内容解密
export const contentDecrypt = (p) => get(`/seller/default/content/decrypt`, p);
